import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconModule } from '../icon/icon.module';
import {
  ButtonComponent,
  ButtonGroupComponent,
  ButtonGroupVerticalComponent,
  ButtonToggleChildComponent,
  ButtonToggleComponent,
  ButtonToolbarComponent,
  ButtonWrapperComponent,
  ToggleBarComponent,
  ToggleButtonComponent,
  ToggleContainerComponent,
  ToggleLabelComponent,
  ToggleSwitchComponent
} from './button.component';
import { ButtonSharedService } from './button.sharedService';
import { AxisResetSelectionComponent } from './resetSelection.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IconModule
  ],
  declarations: [
    AxisResetSelectionComponent,
    ButtonWrapperComponent,
    ButtonComponent,
    ButtonGroupComponent,
    ButtonGroupVerticalComponent,
    ButtonToolbarComponent,
    ButtonToggleComponent,
    ButtonToggleChildComponent,
    ToggleSwitchComponent,
    ToggleContainerComponent,
    ToggleBarComponent,
    ToggleButtonComponent,
    ToggleLabelComponent
  ],
  entryComponents: [AxisResetSelectionComponent],
  exports: [
    ButtonComponent,
    ButtonGroupComponent,
    ButtonWrapperComponent,
    ButtonGroupVerticalComponent,
    FormsModule,
    ButtonToolbarComponent,
    ButtonToggleComponent,
    ButtonToggleChildComponent,
    ToggleSwitchComponent,
    ToggleContainerComponent,
    ToggleBarComponent,
    ToggleButtonComponent,
    ToggleLabelComponent
  ],
  providers: [ButtonSharedService]
})
export class ButtonsModule {}
